import { useMutation } from '@northladder/services';

import { B2B_SERVICE_API } from '../b2bApiClient';

export const SIGN_UP_QUERY_KEY = 'sign-up';

interface ISignUpMutation {
  onSuccessCallback: () => void;
  onErrorCallback: () => void;
}

/**
 * This performs a submit to sign up api request.
 */
export function useSignUpMutation({
  onSuccessCallback,
  onErrorCallback,
}: Readonly<ISignUpMutation>) {
  const { mutate, isPending } = useMutation({
    mutationKey: [SIGN_UP_QUERY_KEY],
    mutationFn: B2B_SERVICE_API.postSignUpForm,
    onError: onErrorCallback,
    onSuccess: onSuccessCallback,
  });

  return {
    isPending,
    submitSignUp: mutate,
  };
}
